// extracted by css-extract-rspack-plugin
export default {"wrapper":"_762e74f4","printHide":"_45002cb6"};